export const copy = (text: string, html?: string) => {
  const handleCopy = (event: ClipboardEvent) => {
    event.preventDefault();

    if (event.clipboardData) {
      event.clipboardData.clearData();
      event.clipboardData.setData('text/plain', text);

      if (html) {
        event.clipboardData.setData('text/html', html);
      }
    }
  };

  document.addEventListener('copy', handleCopy);
  document.execCommand?.('copy');
  document.removeEventListener('copy', handleCopy);
};
